import { useQuery } from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import http from 'hub-http/clients/apiClient';
import ObjectType from 'automation-ui-references/object-types/ObjectType';
import { getEarlyRequest } from 'automation-ui-core/utils/earlyRequesterUtils';
import formatObjectTypesResponse from 'automation-ui-references/object-type-properties/formatObjectTypesResponse';
import { jsx as _jsx } from "react/jsx-runtime";
const emptyObjectType = new ObjectType();
export const GET_OBJECT_TYPE_BY_ID = registerQuery({
  fieldName: 'objectTypeById',
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    return http.get(`inbounddb-meta/v1/object-types/${objectTypeId}`).then(response => new ObjectType(response));
  }
});
export const BATCH_GET_OBJECT_TYPES_BY_IDS = registerQuery({
  fieldName: 'batchObjectTypesByIds',
  args: ['objectTypeIds', 'skipImmutableFormatting'],
  fetcher({
    objectTypeIds,
    skipImmutableFormatting
  }) {
    const callback = skipImmutableFormatting ? response => response : formatObjectTypesResponse;
    return http.get('inbounddb-meta/v1/object-types/batch-get/', {
      query: {
        objectType: objectTypeIds
      }
    }).then(callback);
  }
});
export const GET_ALL_OBJECT_TYPES = registerQuery({
  fieldName: 'automation_allObjectTypes',
  fetcher: () => getEarlyRequest({
    key: 'object-types',
    defaultRequestFn: () => http.get('inbounddb-meta/v1/object-types/for-portal')
  }).then(formatObjectTypesResponse)
});
export const queryObjectTypeById = WrappedComponent => props => {
  const {
    objectTypeId
  } = props;
  const {
    data,
    loading
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !objectTypeId,
    variables: {
      objectTypeId
    }
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectTypeDefinition: new ObjectType(get(data, 'objectTypeById', emptyObjectType)),
    objectTypeDefinitionLoading: loading
  }));
};
export const queryObjectTypeByFlowObjectTypeId = WrappedComponent => props => {
  const {
    flowObjectTypeId
  } = props;
  const {
    data,
    loading
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !flowObjectTypeId,
    variables: {
      objectTypeId: flowObjectTypeId
    }
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectTypeDefinition: new ObjectType(get(data, 'objectTypeById', emptyObjectType)),
    objectTypeDefinitionLoading: loading
  }));
};
export const queryObjectTypeByPropertyTypeId = WrappedComponent => props => {
  const {
    propertyTypeId
  } = props;
  const {
    data,
    loading
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !propertyTypeId,
    variables: {
      objectTypeId: propertyTypeId
    }
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectTypeDefinition: new ObjectType(get(data, 'objectTypeById', emptyObjectType)),
    objectTypeDefinitionLoading: loading
  }));
};